import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  MenuItem,
  Card,
  CardContent,
} from '@mui/material';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { authToken } from '../globals/Global';
import { updateStreamVideo } from '../globals/Services';

export default function VideoManagement() {
  const [videoUrl, setVideoUrl] = useState('');
  const [location, setLocation] = useState('ContentPanelHomeScreen');

  const handleSubmit = async () => {
    if (!videoUrl || !location) {
      toast.error('Both fields are required');
      return;
    }

    try {
        const token = authToken || localStorage.getItem('sessionToken');
        
      const response = await fetch(updateStreamVideo, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, // Assuming you store the token in localStorage
        },
        body: JSON.stringify({ url: videoUrl, location }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update video');
      }

      toast.success('Video updated successfully!');
      setVideoUrl('');
    } catch (error) {
      console.error(error);
      toast.error(`Error: ${error.message}`);
    }
  };

  return (
    <Box p={3}>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Video Management
          </Typography>

          <TextField
            fullWidth
            label="Video URL"
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            margin="normal"
          />

          <TextField
            fullWidth
            select
            label="Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            margin="normal"
          >
            <MenuItem value="ContentPanelHomeScreen">ContentPanelHomeScreen</MenuItem>
            <MenuItem value="ContentPanelHomeScreenLive">ContentPanelHomeScreenLive</MenuItem>
            {/* Add more options as needed */}
          </TextField>

          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{ mt: 2 }}
          >
            Update Video
          </Button>
        </CardContent>
      </Card>

      {/* Add ToastContainer at the end */}
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
    </Box>
  );
}
